import { IBusinessView } from "../business/business";
import { ISelectItems } from "../shared/shared";


export interface ICorrespondenceView{
  id: number;
  typeId: number;
  type: string;
  generatedDate: string;
  sentDate: string;
  hardCopyDate: string;
  letterText: string;
  notes: string;
  title: string;
  discardedCorrespondence: boolean;
  complaintId: number;
  businessId: number;
  businessOnly: boolean;
  hasAttachment: boolean;
  invalidAddress: boolean;
}

export interface IFileView{
  id: number;
  name: string;
  description: string;
  contentType: string;
  contents: Blob;
  uploadedByStaff: boolean;
  staff: string;
  extension: string;
  date: Date;  
}

// export interface IBusinessView{
//   id: number;
//   businessType: number;
//   exempt: boolean;
//   exemptCertificateDate: string;
//   exemptTypeId: number;
//   exemptType: string;
//   exemptStatusId: number;
//   exemptStatus: string;
//   canInspect: boolean;
//   exemptApprovedBy: string;
//   exemptEnteredBy: string;
//   exemptSmokingAllowed: boolean;
//   category: string;
//   active: boolean;
//   inViolation: boolean;
//   countyId: string;
//   countyName: string;
//   stateId: string;
//   businessName: string;
//   businessOwner: string;
//   businessOwnerTitle: string;
//   businessOwnerPhone: string;
//   businessOwnerEmail: string;
//   businessAddress1: string;
//   businessAddress2: string;
//   businessCity: string;
//   businessZip: string;
//   businessZipExt: string;
//   businessPhone: string;
//   businessPhoneExt: string;
//   contactName: string;
//   contactTitle: string;
//   contactEmail: string;
//   notes: string;
//   complaintId: number;
//   associatedBusinessId: string;
//   parentBusinessId: number;
//   parentBusinessName: string;
//   parentBusinessContactFirstName: string;
//   parentBusinessContactLastName: string;
//   parentBusinessContactTitle: string;
//   parentBusinessAddress: string;
//   parentBusinessAddress2: string;
//   parentBusinessCity: string;
//   parentBusinessState: string;
//   parentBusinessZip: string;
//   parentBusinessZipExt: string;
//   parentBusinessPhone: string;
//   parentBusinessPhoneExt: string;
//   parentBusinessEmail: string;
//   useParentBusinessContact: boolean;
//   totalComplaints: number;
//   complaints: IAdministrativeComplaintView[];
//   comments: INotesView[];
//   businessCorrespondence: ICorrespondenceView;
//   lastUpdatedBy: string;
//   lastUpdatedDate: Date;
// }

export class FileViewModel
{
  id: number;
  name: string;
  description: string;
  contentType: string;
  contents: Blob;
  uploadedByStaff: string;
  staff: string;
  extension: string;
  date: Date;
}

export interface INotesView{
  id: number;
  loggedDate: string;
  type: string;
  text: string;
  user: string; 
}

export interface IUnverifiedComplaintsView{
  
  firstValid: boolean;
  complaintDate: string;
  reasonNonActionable: string;
  reasonNonActionableId: number;
  actionable: boolean;
  complaintStatus: string;
  complaintStatusId: number;
  complaintTypeId: number;

  // business
  complaintId: number;
  businessId: number;

  lastSentIrl: Date;
    
  county: string;
  
  businessName: string;
  busniessType: string;
  
  businessExempt: boolean;
  exemptCertificateDate: string;
  exemptTypeId: number;
  exemptType: string;
  exemptStatusId: number;
  exemptStatus: string;
  exemptSmokingAllowed: boolean;
  parentBusinessId: number;
  parentBusinessName: string;
  parentBusinessContactFirstName: string;
  parentBusinessContactLastName: string;
  parentBusinessContactTitle: string;
  parentBusinessAddress: string;
  parentBusinessAddress2: string;
  parentBusinessCity: string;
  parentBusinessState: string;
  parentBusinessZip: string;
  parentBusinessZipExt: string;
  parentBusinessPhone: string;
  parentBusinessPhoneExt: string;
  parentBusinessEmail: string;
  useParentBusinessContact: boolean;
  
  businessActive: boolean;
  address: string;
  address2: string;
  
  city: string;
  
  state: string;
  zip: string;
  zipExt: string;
  typeOfBusiness: string;
  businessPhone: string;
  businessPhoneExtension: string;
  
  complaintComments: string;
  initialComplaintId: number;

  // business contact
  businessContactName: string;
  bbusinessContactTitle: string;
  businessContactEmail: string;
  businessContactPhone: string;
  businessOwner: string;
  businessOwnerTitle: string;
  businessOwnerPhone: string;
  businessOwnerEmail: string;
  
  // contact
  contactName: string;
  contactAddress: string;
  contactCity: string;
  contactState: string;
  contactZip: string;
  contactPhone: string;
  contactPhoneExtension: string;
  isContactAnonymous: boolean;
  
  // correspondence
  businessHasActionableComplaint: boolean;
  businessHasComplaintInPendingSiteVisit: boolean;
  
  initialComplaint: string;
  correspondence: ICorrespondenceView[];
  correspondenceFromOtherComplaints: ICorrespondenceView[];
  files: IFileView[];
  
  businessMatches: IBusinessView[];
  
  associatedBusinessId: string;
  
  listOfStates: ISelectItems[];
  
  selectedNatureOfComplaints: string[];
  
  //Notes
  notes: INotesView[];
  violationTypeIds: string;
    
}

export interface IResponseLettersView{
  complaintId: number;
  complaintDate: Date;
  complaintDateString: string;
  businessName: string;
  address: string;
  city: string;
  zipCode: string;
  generatedDate: Date;
  generatedDateString: string;
  sentDate: Date;
  sentDateString: string;
  hardcopyFiledDate: Date;
  hardcopyFiledDateString: string;
}

export interface IAdministrativeComplaintView{
  firstValid: string;
  complaintDate: string;
  reasonNonActionable: string;
  reasonNonActionableId: string;
  actionable: boolean;
  complaintStatus: string;
  complaintStatusId: number;
  complaintTypeId: number;

  // business
  complaintId: number;
  businessId: number;
  lastSentIrl: Date;
  county: string;
  businessName: string;
  businessType: string;
  businessExempt: boolean;
  exemptCertificateDate: string;
  exemptTypeId: number;
  exemptType: string;
  exemptStatusId: number;
  exemptStatus: string;
  exemptSmokingAllowed: boolean;
  parentBusinessId: number;
  parentBusinessName: string;
  parentBusinessContactFirstName: string;
  parentBusinessContactLastName: string;
  parentBusinessContactTitle: string;
  parentBusinessAddress: string;
  parentBusinessAddress2: string;
  parentBusinessCity: string;
  parentBusinessState: string;
  parentBusinessZip: string;
  parentBusinessZipExt: string;
  parentBusinessPhone: string;
  parentBusinessPhoneExt: string;
  parentBusinessEmail: string;
  useParentBusinessContact: boolean;
  businessActive: boolean;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  zipExt: string;
  typeOfBusiness: string;
  businessPhone: string;
  businessPhoneExtension: string;
  complaintComments: string;
  initialComplaintId: number;

  // business contact
  businessContactName: string;
  businessContactTitle: string;
  businessContactEmail: string;
  businessContactPhone: string;
  businessOwner: string;
  businessOwnerTitle: string;
  businessOwnerPhone: string;
  businessOwnerEmail: string;

  // contact
  contactName: string;
  contactAddress: string;
  contactCity: string;
  contactState: string;
  contactZip: string;
  contactPhone: string;
  contactPhoneExtension: string;
  isContactAnonymous: boolean;

  // correspondence
  businessHasActionableComplaint: boolean;
  businessHasComplaintInPendingSiteVisit: boolean;
  initialComplaint: IComplaintView;
  correspondence: ICorrespondenceView[];
  correspondenceFromOtherComplaints: ICorrespondenceView[];
  files: IFileView[];
  businessMatches: IBusinessView[];
  associatedBusinessId: string;
  listOfStates: ISelectItems[];
  selectedNatureOfComplaints: string[];

  //Notes
  notes: INotesView[];
  violationTypeIds: string;
}

// LetterViewModel
export interface IInitialResponseLettersView{
  complaintId: number;
  complaintDate: Date;
  complaintDateString: string;
  businessName: string;
  address: string;
  city: string;
  zipCode: string;
  generatedDate: Date;
  generatedDateString: string;
  sentDate: Date;
  sentDateString: string;
  hardcopyFiledDate: Date;
  hardcopyFiledDateString: string;
}

export interface IRemediationViewModel{
  id: number;
  complaintId: number;
  businessId: number;
  visitDate: string;
  requiredImplementationDate: string;
  requiredVisitDate: string;
  actualCompletionDate: string;
  vViolationNotes: string;
  correctionRequiredNotes: string;
  remediationResult: string;
  followupDate: string;
  followupConducted: number;
  followupDateConducted: number;
  comments: string;
  postRemediationConducted: number;
  postRemediationDate: string;
  postRemediationResult: string;

  // the 4 fields below from original setup
  // these fields are NOT in Remediation table, 
  // but come from Complaint
  complaintDate: string;
  businessName: string;
  address: string;
  city: string;
  zipCode: string;
}

export interface IBusinessCitationView{
  id: number;
  // id: string;
  // complaintId: string;
  // visitDate: string;
  requiredImplementationDate: string;
  requiredVisitDate: string;
  actualCompletionDate: string;
  violationNotes: string;
  correctionRequiredNotes: string;
  remediationResult: string;
  followupDate: string;
  followupConducted: number;
  followupDateConducted: number;
  comments: string;
  allowEditing: boolean;
  businessId: number;
  complaintId: number;
  canEdit: boolean;
  county: string;
  countyCopyDate: string;
  citationIssuedDate: string;
  fineReceivedDate: string;
  dhsReviewDate: string;
  dojReviewDate: string;
  notIssuedReason: string;
  visitDate: string;
  notes: string;
  finalOrderDate: string;
  penaltyAmt: string;
  settleAgree: string;
  finalOrderReason: string;
  saAmt: string;
  saAbeyance: string;
  saSigned: string;
  saUntil: string;
  saPaid: string;
  citationWarranted: boolean | null;
  hearingRequested: boolean | null;
  hearingDate: string;
  hearingReason: string;
  finalOrderIssued: boolean | null;
  civilPenatly: boolean;
  settlementAgreement: boolean;
  saRequiredAmt: string;
  complaintStatus: string;
  siteVisitDate: string;
  remediationDueDate: string;
  remediationFollowUpDate: string;
  complaintDate: string;
  businessName: string;
  address: string;
  city: string;
  zipCode: string;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  businessFollowupSiteVisitId: number;
  annualExemptInspectionStatusId: number;
  annualExemptInspectionStatus: string;
}

export interface ISiteVisitModel{
  id: number;
  complaintId: number;
  businessId: number;
  origComplaintDate: string;
  subsequentComplaintDate: string;
  visitDate: string;

  allowEditing: boolean;
  notes: string;
  visitConducted: number;
  visitConductedReason: number;
  violationFound: number;
  currentStep: number;
  remediationViewModel: IRemediationViewModel;

  // the 4 fields below from original setup
  // these fields are NOT in SV table, but
  // come from Complaint
  businessName: string;
  address: string;
  city: string;
  zipCode: string;
}

export interface IBusinessExemptInspectionsViewModel{

  id: number;
  complaintId: number;
  visitDate: string;
  requiredImplementationDate: string;
  requiredVisitDate: string;
  actualCompletionDate: string;
  violationNotes: string;
  correctionRequiredNotes: string;
  remediationResult: string;
  followupDate: string;
  followupConducted: number;
  followupDateConducted: number;
  comments: string;
  allowEditing: boolean;
  businessFollowupSiteVisitId: number;
  canEdit: boolean;
  businessName: string;
  businessAddress: string;
  businessCity: string;
  businessZip: string;
  inspectionType: number;
  visitConductedReason: number;
  parentInspectionId: number;
}



// export interface IFollowupVisit{
//   id: number;
//   complaintId: number;
//   businessId: number;
//   visitDate: string;
//   requiredImplementationDate: string;
//   requiredVisitDate: string;
//   actualCompletionDate: string;
//   violationNotes: string;
//   correctionRequiredNotes: string;
//   remediationResult: string;
//   followupDate: string;
//   followupConducted: number;
//   followupDateConducted: number;
//   comments: string;
//   postRemediationConducted: number;
//   postRemediationDate: string;
//   postRemediationResult: string;

//   // the 4 fields below from original setup
//   // these fields are NOT in Remediation table, 
//   // but come from Complaint
//   complaintDate: string;
//   businessName: string;
//   address: string;
//   city: string;
//   zipCode:string;
// }

export interface IPostRemediationPlan{

}

export interface ICitations{
  id: number;
  businessId: number;
  complaintId: number;
  canEdit: boolean;
  county: string;
  countyCopyDate: string;
  citationIssuedDate: string;
  fineReceivedDate: string;
  dhsReviewDate: string;
  dojReviewDate: string;
  notIssuedReason: string;
  visitDate: string;
  notes: string;
  finalOrderDate: string;
  penaltyAmt: string;
  settleAgree: string;
  finalOrderReason: string;
  saAmt: string;
  saAbeyance: string;
  saSigned: string;
  saUntil: string;
  saPaid: string;
  citationWarranted: boolean;
  hearingRequested: boolean;
  hearingDate: string;
  hearingReason: string;
  finalOrderIssued: boolean;
  civilPenatly: boolean;
  settlementAgreement: boolean;
  saRequiredAmt: string;
  complaintStatus: string;
  siteVisitDate: string;
  remediationDueDate: string;
  remediationFollowUpDate: string;
  complaintDate: string;
  businessName: string;
  address: string;
  city: string;
  zipCode: string;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  businessFollowupSiteVisitId: number;
  annualExemptInspectionStatusId: number;
  annualExemptInspectionStatus: string;
}

// export interface IAnnualInspections{

// }

// export interface IBusinessEnclosedAreas{

// }

export interface IEnclosedAreaReportViewModel{
  id: number;
  businessId: number;
  complaintId: number;
  enclosedArea: boolean;
  enclosedAreaReviewed: boolean;
  enclosedAreaAdmin: boolean;
  enclosedAreaDetermination: string;
  enclosedAreaDeterminationComments: string;
  timeStamp: string;
  loggedUser: string;
  visitDate: string;
  visitComments: string;
  comments: string;  
  businessName: string;
  businessActive: boolean;
  businessAddress: string;
  businessCity: string;
  businessZip: string;
  businessExempt: boolean;
  businessCounty: string;
}

export interface IComplaintView{
  
  complaintId: number;
  county: string;
  businessName: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  typeOfBusiness: string;
  businessPhone: string;
  businessPhoneExtension: string;
  complaintComments: string;
  // IFormFile FileToUpload1: File;
  // IFormFile FileToUpload2: File;
  uploadId: number;
  initialComplaintId: number;
  fileContentType: string;
  fileExtension: string;
  fileName: string;
  fileDescription: string;
  contactName: string;
  contactAddress: string;
  contactCity: string;
  contactState: string;
  contactZip: string;
  contactPhone: string;
  contactPhoneExtension: string;
  contactEmail: string;
  contactEmailName: string;
  isContactAnonymous: boolean;
  isContactAnonymousEmail: boolean;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
}

export interface IInitialResponseView{
  complaintDate: Date;
  complaintDateString: string;
  businessName: string;
  address: string;
  city: string;
  zipCode: string;
  generatedDate: Date;
  generatedDateString: string;
  sentDate: Date;
  sentDateString: string;
  hardcopyFiledDate: Date;
  hardcopyFiledDateString: string
}




